
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fighters/[id]",
      function () {
        return require("private-next-pages/fighters/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fighters/[id]"])
      });
    }
  